import type { FieldAccuracyRow } from '@clm/shared-types';

/**
 * The pure half of the Admin **Extraction accuracy** surface — CLM-107. Kept
 * apart from `FieldAccuracy.tsx` for the `pipeline-status-chips.ts` reason: a
 * component module that also exports functions breaks fast refresh, and the
 * ordering rule deserves a test of its own.
 */

/** The 403 copy: this read is `admin:configure`, which is the admin role's alone (R-107-6). */
export const FIELD_ACCURACY_FORBIDDEN_COPY =
  'Extraction accuracy is for administrators (admin:configure). Legal and contributors do not hold that ' +
  'action; the verification queue itself is unchanged for them.';

/** What a rate below the minimum sample reads as — never a number (R-107-7). */
export const TOO_FEW_COPY = 'too few decisions to read';

/**
 * Group by field (alphabetical), the `is_current` grain first within each
 * field, then older grains most-recently-extracted first; schema and model
 * break any remaining tie so the order is total. Derived from the flags, never
 * from the wire order, so the grouping cannot drift from `is_current`. A copy —
 * the response is not mutated.
 */
export function orderFieldAccuracyRows(rows: readonly FieldAccuracyRow[]): FieldAccuracyRow[] {
  return [...rows].sort((a, b) => {
    if (a.field_name !== b.field_name) return a.field_name < b.field_name ? -1 : 1;
    if (a.is_current !== b.is_current) return a.is_current ? -1 : 1;
    if (a.last_extraction_utc !== b.last_extraction_utc) return a.last_extraction_utc > b.last_extraction_utc ? -1 : 1;
    const grainA = `${a.extraction_schema_version} ${a.extraction_model}`;
    const grainB = `${b.extraction_schema_version} ${b.extraction_model}`;
    if (grainA === grainB) return 0;
    return grainA < grainB ? -1 : 1;
  });
}
